import { jsxs as e, jsx as o } from "react/jsx-runtime";
const s = (l) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          fill: "#fff",
          d: "M12 3c1.869 0 3.805.07 5.541.21 2.269.21 4.138 2.03 4.339 4.48l.023.422.024.536q.037.885.073 4.011l-.013.676a80 80 0 0 1-.107 2.976c-.2 2.45-2.069 4.269-4.34 4.48-1.577.126-3.32.197-5.029.207l-.514.002c-1.87 0-3.805-.07-5.541-.21-2.271-.21-4.14-2.03-4.34-4.48l-.023-.423-.017-.359A107 107 0 0 1 2 12.875v-1.751l.013-.67c.024-1.096.06-2.072.103-2.765.2-2.45 2.069-4.27 4.34-4.48a70 70 0 0 1 5.029-.207zm-.002 3.43-.611.002-.59.009a66 66 0 0 0-4.075.198c-.735.07-1.268.63-1.335 1.33l-.022.252c-.062.747-.101 1.797-.125 2.95v1.657l.015.633c.027 1.031.07 1.941.132 2.57.067.699.6 1.26 1.335 1.329 1.33.108 2.697.173 4.074.2l.59.007.652.003.571-.003a67 67 0 0 0 4.665-.207 1.46 1.46 0 0 0 1.335-1.329l.022-.252c.076-.915.118-2.283.138-3.738l-.014-.87-.014-.633c-.028-1.031-.07-1.941-.132-2.57a1.46 1.46 0 0 0-1.335-1.328 66 66 0 0 0-4.075-.2l-.59-.009z"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "url(#open_widget_colored_svg__a)",
          d: "M20.188 4.332a4.74 4.74 0 0 0-2.647-1.122A71 71 0 0 0 12.05 3v3.43l.56.001.59.009a66 66 0 0 1 4.074.2q.192.019.366.08z"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "url(#open_widget_colored_svg__b)",
          d: "M19.907 4.108C21 4.91 21.757 6.181 21.88 7.69l.023.423.025.536q.034.847.07 3.754l-3.232-.145.004-.216-.014-.87-.015-.633c-.028-1.031-.07-1.941-.132-2.57a1.46 1.46 0 0 0-1.248-1.317z"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "url(#open_widget_colored_svg__c)",
          d: "m21.991 11.957.009.702-.013.676a80 80 0 0 1-.107 2.976c-.124 1.507-.879 2.776-1.97 3.578l-2.52-2.544a1.46 1.46 0 0 0 1.219-1.314l.022-.252c.076-.915.118-2.283.138-3.738l-.001-.085z"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "url(#open_widget_colored_svg__d)",
          d: "M20.08 19.757a4.74 4.74 0 0 1-2.54 1.033c-1.577.127-3.32.198-5.029.208l-.515.002q-.271 0-.545-.002l.227-3.43.36.002.57-.003a67 67 0 0 0 4.666-.207 1.6 1.6 0 0 0 .283-.054z"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "url(#open_widget_colored_svg__e)",
          d: "M12.05 21h-.053c-1.87 0-3.805-.07-5.541-.21a4.74 4.74 0 0 1-2.828-1.283L6.19 17.21q.242.122.532.15c1.33.108 2.697.173 4.075.2l.59.007.651.003h.012z"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "url(#open_widget_colored_svg__f)",
          d: "M4.1 19.899c-1.1-.801-1.86-2.075-1.984-3.588l-.023-.424-.017-.359A107 107 0 0 1 2 12.875v-1.392l3.24.152v1.193l.015.633c.027 1.031.07 1.941.132 2.57a1.46 1.46 0 0 0 1.262 1.32z"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "url(#open_widget_colored_svg__g)",
          d: "M2 11.957v-.833l.013-.67c.024-1.096.06-2.072.103-2.765.135-1.65 1.027-3.014 2.289-3.793l2.582 2.722-.265.021c-.735.07-1.268.63-1.335 1.33l-.022.252c-.062.747-.101 1.797-.125 2.95v.786z"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "url(#open_widget_colored_svg__h)",
          d: "M12.213 3h-.212l-.516.002c-1.709.01-3.452.081-5.03.208-.9.083-1.738.42-2.433.949l2.572 2.498a2 2 0 0 1 .128-.018 66 66 0 0 1 4.075-.198l.59-.009.61-.002h.154z"
        }
      ),
      /* @__PURE__ */ e("defs", { children: [
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "open_widget_colored_svg__a",
            x1: 12.261,
            x2: 17.277,
            y1: 5.345,
            y2: 5.607,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { stopColor: "#B349D9" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#F53547" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "open_widget_colored_svg__b",
            x1: 18.29,
            x2: 18.591,
            y1: 5.293,
            y2: 11.501,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { stopColor: "#F13354" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#FF4200" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "open_widget_colored_svg__c",
            x1: 20.545,
            x2: 19.464,
            y1: 12.371,
            y2: 17.468,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { stopColor: "#FF4200" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#FFD000" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "open_widget_colored_svg__d",
            x1: 17.347,
            x2: 12.495,
            y1: 17.77,
            y2: 17.62,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { stopColor: "#FFD000" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#72CE3A" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "open_widget_colored_svg__e",
            x1: 6.547,
            x2: 12.01,
            y1: 18.19,
            y2: 18.307,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { stopColor: "#02B296" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#72CE3A" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "open_widget_colored_svg__f",
            x1: 3.611,
            x2: 5.12,
            y1: 12.003,
            y2: 17.641,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { stopColor: "#2173DA" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#02B195" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "open_widget_colored_svg__g",
            x1: 6.717,
            x2: 4.94,
            y1: 7.492,
            y2: 10.074,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { stopColor: "#3750FF" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#2172D9" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "open_widget_colored_svg__h",
            x1: 11.58,
            x2: 6.294,
            y1: 4.978,
            y2: 4.209,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { stopColor: "#B44ADA" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#364FFE" })
            ]
          }
        )
      ] })
    ]
  }
);
export {
  s as default
};
